var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf"},_vm._l((_vm.numPages),function(i){return _c('pdf',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],key:i,attrs:{"src":_vm.pdfUrl,"page":i}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }